// INVARIANT: Logs have no side effects — they explain, not control (see docs/invariants/PHASE_3_INVARIANTS.md)
/**
 * Debug utility for development-only logging
 * In production builds, only errors are logged
 */

const isDev = import.meta.env.DEV;

export const debug = {
  log: (...args: any[]) => {
    if (isDev) {
      console.log(...args);
    }
  },
  warn: (...args: any[]) => {
    if (isDev) {
      console.warn(...args);
    }
  },
  error: (...args: any[]) => {
    // Always log errors, even in production
    console.error(...args);
  },
  info: (...args: any[]) => {
    if (isDev) {
      console.info(...args);
    }
  },
};
